﻿import MyHttp from './MyHttp';

const getConfig = function(){
    return MyHttp.getJson('./static/config.json')
};

export default {
    getConfig
}


// WEBPACK FOOTER //
// ./src/api/config.js